// api.ts - CORRECTED VERSION
import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  bxApiClient,
  receiptApiClient,
} from "@shared/api/clients/apiClientFactory";
import { QueryStringParameters } from "@shared/api/url-builder";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
// api/mockApiResponse.ts
/**
 * Complete Mock API Response
 *
 * This shows the exact structure your API should return for the
 * template system to work properly.
 */

export const MOCK_API_RESPONSE = {
  result: [
    {
      id: 119,
      componentName: "Logo",
      componentAlias: "logo",
      htmlData:
        '<div data-component="logo" style="text-align: center; padding: 20px;">\n            <img data-role="logo-image" src="https://bynry.com/images/logos/BYNRY_Logo_RGB.png" alt="Company Logo" style="max-width: 150px; height: auto;">\n        </div>',
      htmlSkeleton:
        '<div data-component="logo" style="text-align: center; padding: 20px;">\n            <img data-role="logo-image" src="{{logo_url}}" alt="{{company_name}}" style="max-width: 150px; height: auto;">\n        </div>',
      defaultSize: {
        width: 200,
        height: 150,
      },
      configuration: {
        category: "branding",
        defaultSize: {
          width: 200,
          height: 150,
        },
        available_fields: [
          {
            field_key: "logo_url",
            data_source: "utility.logo_url",
            field_label: "Logo Image",
          },
        ],
      },
      isActive: true,
    },
    {
      id: 120,
      componentName: "Customer Details",
      componentAlias: "customer_details",
      htmlData:
        '<div data-component="customer_details" style="border: 2px solid #e5e7eb; border-radius: 8px; padding: 20px; background: #ffffff;">\n            <h3 data-role="header" style="margin: 0 0 15px 0; font-size: 16px; font-weight: bold; color: #1f2937;">BILLING TO</h3>\n            <div data-role="fields-container" style="display: grid; grid-template-columns: 150px 1fr; gap: 8px; font-size: 14px;">\n\n                <div data-field="name" data-field-source="customer.name" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Name:</div>\n                    <div data-role="value">Setelite SUA</div>\n                </div>\n\n                <div data-field="email" data-field-source="customer.email" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Email:</div>\n                    <div data-role="value">sandeepmauryadesigns@gmail.com</div>\n                </div>\n\n                <div data-field="phone" data-field-source="customer.phone" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Phone:</div>\n                    <div data-role="value">+91 98765 43210</div>\n                </div>\n\n                <div data-field="account_no" data-field-source="account.account_number" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Account No:</div>\n                    <div data-role="value">12019-001</div>\n                </div>\n\n                <div data-field="utility_services" data-field-source="account.services" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Utility Services:</div>\n                    <div data-role="value">Water</div>\n                </div>\n\n                <div data-field="mailing_address" data-field-source="customer.mailing_address" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Mailing Address:</div>\n                    <div data-role="value">C/O-TOVA SUA (SWA) MATAUTU UTA</div>\n                </div>\n\n                <div data-field="service_address" data-field-source="customer.service_address" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Service Address:</div>\n                    <div data-role="value">C/O-TOVA SUA (SWA) MATAUTU UTA</div>\n                </div>\n\n                <div data-field="plan" data-field-source="account.plan_name" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Plan:</div>\n                    <div data-role="value">Standard Water Plan</div>\n                </div>\n\n                <div data-field="category" data-field-source="customer.category" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Category:</div>\n                    <div data-role="value">Commercial</div>\n                </div>\n\n                <div data-field="sub_category" data-field-source="customer.sub_category" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Sub-category:</div>\n                    <div data-role="value">Government</div>\n                </div>\n\n            </div>\n        </div>',
      htmlSkeleton:
        '<div data-component="customer_details" style="border: 2px solid #e5e7eb; border-radius: 8px; padding: 20px; background: #ffffff;">\n            <h3 data-role="header" style="margin: 0 0 15px 0; font-size: 16px; font-weight: bold; color: #1f2937;">{{header_text}}</h3>\n            <div data-role="fields-container" style="display: grid; grid-template-columns: 150px 1fr; gap: 8px; font-size: 14px;">\n\n                <div data-field="name" data-field-source="customer.name" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.name.label}}:</div>\n                    <div data-role="value">{{customer.name}}</div>\n                </div>\n\n                <div data-field="email" data-field-source="customer.email" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.email.label}}:</div>\n                    <div data-role="value">{{customer.email}}</div>\n                </div>\n\n                <div data-field="phone" data-field-source="customer.phone" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.phone.label}}:</div>\n                    <div data-role="value">{{customer.phone}}</div>\n                </div>\n\n                <div data-field="account_no" data-field-source="account.account_number" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.account_no.label}}:</div>\n                    <div data-role="value">{{account.account_number}}</div>\n                </div>\n\n                <div data-field="utility_services" data-field-source="account.services" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.utility_services.label}}:</div>\n                    <div data-role="value">{{account.services}}</div>\n                </div>\n\n                <div data-field="mailing_address" data-field-source="customer.mailing_address" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.mailing_address.label}}:</div>\n                    <div data-role="value">{{customer.mailing_address}}</div>\n                </div>\n\n                <div data-field="service_address" data-field-source="customer.service_address" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.service_address.label}}:</div>\n                    <div data-role="value">{{customer.service_address}}</div>\n                </div>\n\n                <div data-field="plan" data-field-source="account.plan_name" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.plan.label}}:</div>\n                    <div data-role="value">{{account.plan_name}}</div>\n                </div>\n\n                <div data-field="category" data-field-source="customer.category" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.category.label}}:</div>\n                    <div data-role="value">{{customer.category}}</div>\n                </div>\n\n                <div data-field="sub_category" data-field-source="customer.sub_category" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.sub_category.label}}:</div>\n                    <div data-role="value">{{customer.sub_category}}</div>\n                </div>\n\n            </div>\n        </div>',
      defaultSize: {
        width: 500,
        height: 350,
      },
      configuration: {
        category: "customer",
        defaultSize: {
          width: 500,
          height: 350,
        },
        available_fields: [
          {
            field_key: "name",
            field_type: "string",
            data_source: "customer.name",
            field_label: "Name",
            is_required: true,
            default_order: 1,
          },
          {
            field_key: "email",
            field_type: "email",
            data_source: "customer.email",
            field_label: "Email",
            is_required: false,
            default_order: 2,
          },
          {
            field_key: "phone",
            field_type: "tel",
            data_source: "customer.phone",
            field_label: "Phone",
            is_required: false,
            default_order: 3,
          },
          {
            field_key: "account_no",
            field_type: "string",
            data_source: "account.account_number",
            field_label: "Account No",
            is_required: false,
            default_order: 4,
          },
          {
            field_key: "utility_services",
            field_type: "string",
            data_source: "account.services",
            field_label: "Utility Services",
            is_required: false,
            default_order: 5,
          },
          {
            field_key: "mailing_address",
            field_type: "text",
            data_source: "customer.mailing_address",
            field_label: "Mailing Address",
            is_required: false,
            default_order: 6,
          },
          {
            field_key: "service_address",
            field_type: "text",
            data_source: "customer.service_address",
            field_label: "Service Address",
            is_required: false,
            default_order: 7,
          },
          {
            field_key: "plan",
            field_type: "string",
            data_source: "account.plan_name",
            field_label: "Plan",
            is_required: false,
            default_order: 8,
          },
          {
            field_key: "category",
            field_type: "string",
            data_source: "customer.category",
            field_label: "Category",
            is_required: false,
            default_order: 9,
          },
          {
            field_key: "sub_category",
            field_type: "string",
            data_source: "customer.sub_category",
            field_label: "Sub-category",
            is_required: false,
            default_order: 10,
          },
        ],
      },
      isActive: true,
    },
    {
      id: 121,
      componentName: "Invoice Details",
      componentAlias: "invoice_details",
      htmlData:
        '<div data-component="invoice_details" style="border: 2px solid #e5e7eb; border-radius: 8px; padding: 20px; background: #f9fafb;">\n            <h3 data-role="header" style="margin: 0 0 15px 0; font-size: 16px; font-weight: bold; color: #1f2937;">INVOICE INFORMATION</h3>\n            <div data-role="fields-container" style="display: grid; grid-template-columns: 180px 1fr; gap: 8px; font-size: 14px;">\n\n                <div data-field="invoice_no" data-field-source="invoice.invoice_number" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Invoice No:</div>\n                    <div data-role="value">123000123000</div>\n                </div>\n\n                <div data-field="invoice_date" data-field-source="invoice.invoice_date" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Invoice Date:</div>\n                    <div data-role="value">03 Jul 2024</div>\n                </div>\n\n                <div data-field="invoice_period" data-field-source="invoice.billing_period" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Invoice Period:</div>\n                    <div data-role="value">01 Jun 2024 – 30 Jun 2024</div>\n                </div>\n\n                <div data-field="service_period" data-field-source="invoice.meter_reading_period" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Service Period:</div>\n                    <div data-role="value">10 Jun 2024 – 05 Jul 2024</div>\n                </div>\n\n                <div data-field="due_date" data-field-source="invoice.due_date" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Due Date:</div>\n                    <div data-role="value">20 Jul 2024</div>\n                </div>\n\n                <div data-field="amount" data-field-source="invoice.total_amount" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">Amount:</div>\n                    <div data-role="value" style="font-size: 18px; font-weight: bold; color: #dc2626;">$$408.87</div>\n                </div>\n\n            </div>\n        </div>',
      htmlSkeleton:
        '<div data-component="invoice_details" style="border: 2px solid #e5e7eb; border-radius: 8px; padding: 20px; background: #f9fafb;">\n            <h3 data-role="header" style="margin: 0 0 15px 0; font-size: 16px; font-weight: bold; color: #1f2937;">{{header_text}}</h3>\n            <div data-role="fields-container" style="display: grid; grid-template-columns: 180px 1fr; gap: 8px; font-size: 14px;">\n\n                <div data-field="invoice_no" data-field-source="invoice.invoice_number" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.invoice_no.label}}:</div>\n                    <div data-role="value">{{invoice.invoice_number}}</div>\n                </div>\n\n                <div data-field="invoice_date" data-field-source="invoice.invoice_date" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.invoice_date.label}}:</div>\n                    <div data-role="value">{{invoice.invoice_date}}</div>\n                </div>\n\n                <div data-field="invoice_period" data-field-source="invoice.billing_period" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.invoice_period.label}}:</div>\n                    <div data-role="value">{{invoice.billing_period}}</div>\n                </div>\n\n                <div data-field="service_period" data-field-source="invoice.meter_reading_period" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.service_period.label}}:</div>\n                    <div data-role="value">{{invoice.meter_reading_period}}</div>\n                </div>\n\n                <div data-field="due_date" data-field-source="invoice.due_date" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.due_date.label}}:</div>\n                    <div data-role="value">{{invoice.due_date}}</div>\n                </div>\n\n                <div data-field="amount" data-field-source="invoice.total_amount" style="display: contents;">\n                    <div data-role="label" style="font-weight: 600;">{{fields.amount.label}}:</div>\n                    <div data-role="value" style="font-size: 18px; font-weight: bold; color: #dc2626;">${{invoice.total_amount}}</div>\n                </div>\n\n            </div>\n        </div>',
      defaultSize: {
        width: 450,
        height: 250,
      },
      configuration: {
        category: "invoice",
        defaultSize: {
          width: 450,
          height: 250,
        },
        available_fields: [
          {
            field_key: "invoice_no",
            field_type: "string",
            data_source: "invoice.invoice_number",
            field_label: "Invoice No",
            is_required: true,
            default_order: 1,
          },
          {
            field_key: "invoice_date",
            field_type: "date",
            data_source: "invoice.invoice_date",
            field_label: "Invoice Date",
            is_required: true,
            default_order: 2,
          },
          {
            field_key: "invoice_period",
            field_type: "string",
            data_source: "invoice.billing_period",
            field_label: "Invoice Period",
            is_required: false,
            default_order: 3,
          },
          {
            field_key: "service_period",
            field_type: "string",
            data_source: "invoice.meter_reading_period",
            field_label: "Service Period",
            is_required: false,
            default_order: 4,
          },
          {
            field_key: "due_date",
            field_type: "date",
            data_source: "invoice.due_date",
            field_label: "Due Date",
            is_required: true,
            default_order: 5,
          },
          {
            field_key: "amount",
            field_type: "currency",
            data_source: "invoice.total_amount",
            field_label: "Amount",
            is_required: true,
            default_order: 6,
          },
        ],
      },
      isActive: true,
    },
    {
      id: 122,
      componentName: "Current Meter Reading",
      componentAlias: "current_meter_reading",
      htmlData:
        '<div data-component="current_meter_reading" style="border: 2px solid #e5e7eb; border-radius: 8px; padding: 20px;">\n            <h3 data-role="header" style="margin: 0 0 15px 0; font-size: 16px; font-weight: bold; color: #1f2937;">\n                CURRENT METER READING\n            </h3>\n\n            <table data-role="table" style="width: 100%; border-collapse: collapse; font-size: 14px;">\n                <thead>\n                    <tr style="background-color: #f3f4f6;">\n                        <th data-field-header="utility_service" style="border: 1px solid #d1d5db; padding: 8px; text-align: left;">Utility Service</th>\n                        <th data-field-header="meter_no" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Meter No</th>\n                        <th data-field-header="device_no" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Device No</th>\n                        <th data-field-header="prev_read" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Prev Read</th>\n                        <th data-field-header="prev_date" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Prev Date</th>\n                        <th data-field-header="prev_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Prev Status</th>\n                        <th data-field-header="prev_vee_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Prev VEE Status</th>\n                        <th data-field-header="curr_read" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Curr Read</th>\n                        <th data-field-header="curr_date" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Curr Date</th>\n                        <th data-field-header="curr_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Curr Status</th>\n                        <th data-field-header="curr_vee_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Curr VEE Status</th>\n                        <th data-field-header="consumption" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Consumption</th>\n                    </tr>\n                </thead>\n\n                <tbody>\n                    \n                    <tr>\n                        <td data-field-value="utility_service" style="border: 1px solid #d1d5db; padding: 8px;">Water</td>\n                        <td data-field-value="meter_no" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">12042772</td>\n                        <td data-field-value="device_number" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">DEV-88991</td>\n                        <td data-field-value="previous_reading" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">1200</td>\n                        <td data-field-value="previous_date" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">10 Jun 2024</td>\n                        <td data-field-value="previous_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Actual</td>\n                        <td data-field-value="previous_vee_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Valid</td>\n                        <td data-field-value="current_reading" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">1250</td>\n                        <td data-field-value="current_date" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">05 Jul 2024</td>\n                        <td data-field-value="current_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Actual</td>\n                        <td data-field-value="current_vee_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Valid</td>\n                        <td data-field-value="consumption" style="border: 1px solid #d1d5db; padding: 8px; text-align: center; font-weight: 600;">50</td>\n                    </tr>\n                    \n                </tbody>\n            </table>\n        </div>\n        ',
      htmlSkeleton:
        '<div data-component="current_meter_reading" style="border: 2px solid #e5e7eb; border-radius: 8px; padding: 20px;">\n            <h3 data-role="header" style="margin: 0 0 15px 0; font-size: 16px; font-weight: bold; color: #1f2937;">\n                {{header_text}}\n            </h3>\n\n            <table data-role="table" style="width: 100%; border-collapse: collapse; font-size: 14px;">\n                <thead>\n                    <tr style="background-color: #f3f4f6;">\n                        <th data-field-header="utility_service" style="border: 1px solid #d1d5db; padding: 8px; text-align: left;">{{fields.utility_service.label}}</th>\n                        <th data-field-header="meter_no" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.meter_no.label}}</th>\n                        <th data-field-header="device_no" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.device_no.label}}</th>\n                        <th data-field-header="prev_read" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.prev_read.label}}</th>\n                        <th data-field-header="prev_date" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.prev_date.label}}</th>\n                        <th data-field-header="prev_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.prev_status.label}}</th>\n                        <th data-field-header="prev_vee_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.prev_vee_status.label}}</th>\n                        <th data-field-header="curr_read" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.curr_read.label}}</th>\n                        <th data-field-header="curr_date" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.curr_date.label}}</th>\n                        <th data-field-header="curr_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.curr_status.label}}</th>\n                        <th data-field-header="curr_vee_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.curr_vee_status.label}}</th>\n                        <th data-field-header="consumption" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{fields.consumption.label}}</th>\n                    </tr>\n                </thead>\n\n                <tbody>\n                    {% for meter in meters %}\n                    <tr>\n                        <td data-field-value="utility_service" style="border: 1px solid #d1d5db; padding: 8px;">{{meter.utility_service}}</td>\n                        <td data-field-value="meter_no" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{meter.meter_number}}</td>\n                        <td data-field-value="device_number" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{meter.device_number}}</td>\n                        <td data-field-value="previous_reading" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{meter.previous_reading}}</td>\n                        <td data-field-value="previous_date" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{meter.previous_date}}</td>\n                        <td data-field-value="previous_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{meter.previous_status}}</td>\n                        <td data-field-value="previous_vee_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{meter.previous_vee_status}}</td>\n                        <td data-field-value="current_reading" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{meter.current_reading}}</td>\n                        <td data-field-value="current_date" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{meter.current_date}}</td>\n                        <td data-field-value="current_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{meter.current_status}}</td>\n                        <td data-field-value="current_vee_status" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{meter.current_vee_status}}</td>\n                        <td data-field-value="consumption" style="border: 1px solid #d1d5db; padding: 8px; text-align: center; font-weight: 600;">{{meter.consumption}}</td>\n                    </tr>\n                    {% endfor %}\n                </tbody>\n            </table>\n        </div>\n        ',
      defaultSize: {
        width: 700,
        height: 200,
      },
      configuration: {
        category: "meter",
        defaultSize: {
          width: 700,
          height: 200,
        },
        available_fields: [
          {
            field_key: "utility_service",
            field_type: "string",
            data_source: "meter.utility_service",
            field_label: "Utility Service",
            default_order: 1,
          },
          {
            field_key: "meter_no",
            field_type: "string",
            data_source: "meter.meter_number",
            field_label: "Meter No",
            default_order: 2,
          },
          {
            field_key: "device_no",
            field_type: "string",
            data_source: "meter.device_number",
            field_label: "Device No",
            default_order: 3,
          },
          {
            field_key: "prev_read",
            field_type: "number",
            data_source: "meter.previous_reading",
            field_label: "Prev Read",
            default_order: 4,
          },
          {
            field_key: "prev_date",
            field_type: "date",
            data_source: "meter.previous_date",
            field_label: "Prev Date",
            default_order: 5,
          },
          {
            field_key: "prev_status",
            field_type: "string",
            data_source: "meter.previous_status",
            field_label: "Prev Status",
            default_order: 6,
          },
          {
            field_key: "prev_vee_status",
            field_type: "string",
            data_source: "meter.previous_vee_status",
            field_label: "Prev VEE Status",
            default_order: 7,
          },
          {
            field_key: "curr_read",
            field_type: "number",
            data_source: "meter.current_reading",
            field_label: "Curr Read",
            default_order: 8,
          },
          {
            field_key: "curr_date",
            field_type: "date",
            data_source: "meter.current_date",
            field_label: "Curr Date",
            default_order: 9,
          },
          {
            field_key: "curr_status",
            field_type: "string",
            data_source: "meter.current_status",
            field_label: "Curr Status",
            default_order: 10,
          },
          {
            field_key: "curr_vee_status",
            field_type: "string",
            data_source: "meter.current_vee_status",
            field_label: "Curr VEE Status",
            default_order: 11,
          },
          {
            field_key: "consumption",
            field_type: "number",
            data_source: "meter.consumption",
            field_label: "Consumption",
            default_order: 12,
          },
        ],
      },
      isActive: true,
    },
    {
      id: 123,
      componentName: "Old Meter Details",
      componentAlias: "old_meter_details",
      htmlData:
        '<div data-component="old_meter_details" style="border: 2px solid #fbbf24; border-radius: 8px; padding: 20px; background: #fffbeb;">\n                <h3 data-role="header" style="margin-bottom: 10px; font-size: 16px; font-weight: bold; color: #92400e;">\n                    OLD METER DETAILS\n                </h3>\n\n                <table data-role="table" style="width: 100%; border-collapse: collapse; font-size: 14px;">\n                    <thead>\n                        <tr style="background-color: #fef3c7;">\n                            <th data-field-header="utility_service" style="border: 1px solid #fbbf24; padding: 8px; text-align: left;">Utility Service</th>\n                            <th data-field-header="meter_no" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Meter No</th>\n                            <th data-field-header="device_no" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Device No</th>\n                            <th data-field-header="prev_read" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Prev Read</th>\n                            <th data-field-header="prev_date" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Prev Date</th>\n                            <th data-field-header="prev_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Prev Status</th>\n                            <th data-field-header="prev_vee_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Prev VEE Status</th>\n                            <th data-field-header="curr_read" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Curr Read</th>\n                            <th data-field-header="curr_date" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Curr Date</th>\n                            <th data-field-header="curr_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Curr Status</th>\n                            <th data-field-header="curr_vee_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Curr VEE Status</th>\n                            <th data-field-header="consumption" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Consumption</th>\n                        </tr>\n                    </thead>\n\n                    <tbody>\n                        \n                        <tr>\n                            <td data-field-value="utility_service" style="border: 1px solid #fbbf24; padding: 8px;">Water</td>\n                            <td data-field-value="meter_no" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">OLD-99821</td>\n                            <td data-field-value="device_no" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">OLD-DEV-1122</td>\n                            <td data-field-value="prev_read" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">950</td>\n                            <td data-field-value="prev_date" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">01 May 2024</td>\n                            <td data-field-value="previous_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Actual</td>\n                            <td data-field-value="previous_vee_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Valid</td>\n                            <td data-field-value="current_reading" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">1200</td>\n                            <td data-field-value="current_date" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">10 Jun 2024</td>\n                            <td data-field-value="current_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Final</td>\n                            <td data-field-value="current_vee_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">Valid</td>\n                            <td data-field-value="consumption" style="border: 1px solid #fbbf24; padding: 8px; text-align: center; font-weight: 600;">250</td>\n                        </tr>\n                        \n                    </tbody>\n                </table>\n            </div>',
      htmlSkeleton:
        '<div data-component="old_meter_details" style="border: 2px solid #fbbf24; border-radius: 8px; padding: 20px; background: #fffbeb;">\n                <h3 data-role="header" style="margin-bottom: 10px; font-size: 16px; font-weight: bold; color: #92400e;">\n                    {{header_text}}\n                </h3>\n\n                <table data-role="table" style="width: 100%; border-collapse: collapse; font-size: 14px;">\n                    <thead>\n                        <tr style="background-color: #fef3c7;">\n                            <th data-field-header="utility_service" style="border: 1px solid #fbbf24; padding: 8px; text-align: left;">{{fields.utility_service.label}}</th>\n                            <th data-field-header="meter_no" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.meter_no.label}}</th>\n                            <th data-field-header="device_no" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.device_no.label}}</th>\n                            <th data-field-header="prev_read" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.prev_read.label}}</th>\n                            <th data-field-header="prev_date" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.prev_date.label}}</th>\n                            <th data-field-header="prev_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.prev_status.label}}</th>\n                            <th data-field-header="prev_vee_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.prev_vee_status.label}}</th>\n                            <th data-field-header="curr_read" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.curr_read.label}}</th>\n                            <th data-field-header="curr_date" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.curr_date.label}}</th>\n                            <th data-field-header="curr_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.curr_status.label}}</th>\n                            <th data-field-header="curr_vee_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.curr_vee_status.label}}</th>\n                            <th data-field-header="consumption" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{fields.consumption.label}}</th>\n                        </tr>\n                    </thead>\n\n                    <tbody>\n                        {% for meter in old_meters %}\n                        <tr>\n                            <td data-field-value="utility_service" style="border: 1px solid #fbbf24; padding: 8px;">{{meter.utility_service}}</td>\n                            <td data-field-value="meter_no" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{meter.meter_number}}</td>\n                            <td data-field-value="device_no" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{meter.device_number}}</td>\n                            <td data-field-value="prev_read" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{meter.previous_reading}}</td>\n                            <td data-field-value="prev_date" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{meter.previous_date}}</td>\n                            <td data-field-value="previous_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{meter.previous_status}}</td>\n                            <td data-field-value="previous_vee_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{meter.previous_vee_status}}</td>\n                            <td data-field-value="current_reading" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{meter.current_reading}}</td>\n                            <td data-field-value="current_date" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{meter.current_date}}</td>\n                            <td data-field-value="current_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{meter.current_status}}</td>\n                            <td data-field-value="current_vee_status" style="border: 1px solid #fbbf24; padding: 8px; text-align: center;">{{meter.current_vee_status}}</td>\n                            <td data-field-value="consumption" style="border: 1px solid #fbbf24; padding: 8px; text-align: center; font-weight: 600;">{{meter.consumption}}</td>\n                        </tr>\n                        {% endfor %}\n                    </tbody>\n                </table>\n            </div>',
      defaultSize: {
        width: 650,
        height: 200,
      },
      configuration: {
        category: "meter",
        defaultSize: {
          width: 650,
          height: 200,
        },
        available_fields: [
          {
            field_key: "utility_service",
            field_type: "string",
            data_source: "old_meter.utility_service",
            field_label: "Utility Service",
            default_order: 1,
          },
          {
            field_key: "meter_no",
            field_type: "string",
            data_source: "old_meter.meter_number",
            field_label: "Meter No",
            default_order: 2,
          },
          {
            field_key: "device_no",
            field_type: "string",
            data_source: "old_meter.device_number",
            field_label: "Device No",
            default_order: 3,
          },
          {
            field_key: "prev_read",
            field_type: "number",
            data_source: "old_meter.previous_reading",
            field_label: "Prev Read",
            default_order: 4,
          },
          {
            field_key: "prev_date",
            field_type: "date",
            data_source: "old_meter.previous_date",
            field_label: "Prev Date",
            default_order: 5,
          },
          {
            field_key: "prev_status",
            field_type: "string",
            data_source: "old_meter.previous_status",
            field_label: "Prev Status",
            default_order: 6,
          },
          {
            field_key: "prev_vee_status",
            field_type: "string",
            data_source: "old_meter.previous_vee_status",
            field_label: "Prev VEE Status",
            default_order: 7,
          },
          {
            field_key: "curr_read",
            field_type: "number",
            data_source: "old_meter.current_reading",
            field_label: "Curr Read",
            default_order: 8,
          },
          {
            field_key: "curr_date",
            field_type: "date",
            data_source: "old_meter.current_date",
            field_label: "Curr Date",
            default_order: 9,
          },
          {
            field_key: "curr_status",
            field_type: "string",
            data_source: "old_meter.current_status",
            field_label: "Curr Status",
            default_order: 10,
          },
          {
            field_key: "curr_vee_status",
            field_type: "string",
            data_source: "old_meter.current_vee_status",
            field_label: "Curr VEE Status",
            default_order: 11,
          },
          {
            field_key: "consumption",
            field_type: "number",
            data_source: "old_meter.consumption",
            field_label: "Consumption",
            default_order: 12,
          },
        ],
        visibility_condition: "bill_category == 'meter_replacement'",
      },
      isActive: true,
    },
    {
      id: 124,
      componentName: "Text Box",
      componentAlias: "text_box",
      htmlData:
        '<div data-component="text_box" style="padding: 15px; border: 1px dashed #9ca3af; border-radius: 4px; background: #f9fafb;">\n            <div data-role="editable-content" contenteditable="true">\n                <p style="margin: 0; font-size: 14px; color: #374151;">\n                    Click to edit this text. You can add any content here and style it using the configuration panel.\n                </p>\n            </div>\n        </div>',
      htmlSkeleton:
        '<div data-component="text_box" style="padding: 15px; border: 1px dashed #9ca3af; border-radius: 4px; background: #f9fafb;">\n            <div data-role="editable-content" contenteditable="true">\n                <p style="margin: 0; font-size: 14px; color: #374151;">\n                    Click to edit this text. You can add any content here and style it using the configuration panel.\n                </p>\n            </div>\n        </div>',
      defaultSize: {
        width: 500,
        height: 100,
      },
      configuration: {
        category: "layout",
        editable: true,
        defaultSize: {
          width: 500,
          height: 100,
        },
        supports_rich_text: true,
      },
      isActive: true,
    },
    {
      id: 125,
      componentName: "Box",
      componentAlias: "box",
      htmlData:
        '<div data-component="box" style="width: 100%; height: 100%; border: 2px solid #e5e7eb; border-radius: 4px; background: #ffffff;">\n            <!-- Empty styled container -->\n        </div>',
      htmlSkeleton:
        '<div data-component="box" style="width: 100%; height: 100%; border: 2px solid #e5e7eb; border-radius: 4px; background: #ffffff;">\n            <!-- Empty styled container -->\n        </div>',
      defaultSize: {
        width: 300,
        height: 200,
      },
      configuration: {
        category: "layout",
        defaultSize: {
          width: 300,
          height: 200,
        },
        customizable_styles: [
          "border",
          "background",
          "border-radius",
          "padding",
        ],
      },
      isActive: true,
    },
    {
      id: 126,
      componentName: "Consumption & Service Charges",
      componentAlias: "consumption_service_charges",
      htmlData:
        '\n    <div data-component="consumption_service_charges"\n         style="border: 2px solid #e5e7eb; border-radius: 8px; padding: 20px; background: #ffffff;">\n\n        <h3 data-role="header" style="margin-bottom: 15px; font-size: 16px; font-weight: bold;">\n            CONSUMPTION &amp; SERVICE CHARGES\n        </h3>\n\n        \n\n        \n\n        \n\n        \n\n        \n\n        \n\n    </div>\n    ',
      htmlSkeleton:
        '\n    <div data-component="consumption_service_charges"\n         style="border: 2px solid #e5e7eb; border-radius: 8px; padding: 20px; background: #ffffff;">\n\n        <h3 data-role="header" style="margin-bottom: 15px; font-size: 16px; font-weight: bold;">\n            {{header_text}}\n        </h3>\n\n        {% if fields.consumption_charges.active %}\n        <h4>{{fields.consumption_charges.label}}</h4>\n        <table style="width:100%; border-collapse: collapse; font-size:14px;">\n            <thead>\n                <tr>\n                    <th data-field-header="utility_service" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">Utility Service</th>                    <th data-field-header="consumption">Consumption</th>\n                    <th data-field-header="tariff_structure" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">Tariff Structure</th>\n                    <th data-field-header="tariff" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">Tariff</th>\n                    <th data-field-header="amount" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">Amount</th>\n                </tr>\n            </thead>\n            <tbody>\n                {% for row in billing.consumption_charges %}\n                <tr>\n                    <td data-field-header="utility_service" style="border: 1px solid #D1D5DB; padding: 8px;>{{row.utility_service}}</td>\n                    <td data-field-header="consumption" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">{{row.consumption}}</td>\n                    <td data-field-header="tariff_structure" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">{{row.tariff_structure}}</td>\n                    <td data-field-header="tariff" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">{{row.tariff}}</td>\n                    <td data-field-header="amount" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left; font-weight: 600;">{{row.amount}}</td>\n                </tr>\n                {% endfor %}\n            </tbody>\n        </table>\n        {% endif %}\n\n        {% if fields.service_charges.active %}\n        <h4>{{fields.service_charges.label}}</h4>\n        <table style="width:100%; border-collapse: collapse; font-size:14px;">\n            <thead>\n                <tr>\n                    <th data-field-header="utility_service" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">Utility Service</th>                    \n                    <th data-field-header="charge_type" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">Charge Type</th>\n                    <th data-field-header="amount" style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">Amount</th>\n                </tr>\n            </thead>\n            <tbody>\n                {% for row in billing.service_charges %}\n                <tr>\n                    <td data-field-value="utility_service" style="border: 1px solid #d1d5db; padding: 8px;">{{row.utility_service}}</td>\n                    <td data-field-value="meter_no" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{row.charge_name}}</td>\n                    <td data-field-value="meter_no" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">{{row.charge_type}}</td>\n                    <td data-field-value="consumption" style="border: 1px solid #d1d5db; padding: 8px; text-align: center; font-weight: 600;">{{row.amount}}</td>\n                </tr>\n                {% endfor %}\n            </tbody>\n        </table>\n        {% endif %}\n\n        {% if fields.other_charges.active %}\n        <h4>{{fields.other_charges.label}}</h4>\n        <table style="width:100%; border-collapse: collapse; font-size:14px;">\n            <thead>\n                <tr>\n                    <th data-field-header="charge_name" style="border: 1px solid #d1d5db; padding: 8px; text-align: left;">Charge</th>\n                    <th data-field-header="amount" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">Amount</th>\n                </tr>\n            </thead>\n            <tbody>\n                {% for row in billing.other_charges %}\n                <tr>\n                    <td data-field-value="charge_name" style="border: 1px solid #d1d5db; padding: 8px;">{{row.charge_name}}</td>\n                    <td data-field-value="amount" style="border: 1px solid #d1d5db; padding: 8px; text-align: center; font-weight: 600;">{{row.amount}}</td>\n                </tr>\n                {% endfor %}\n            </tbody>\n        </table>\n        {% endif %}\n\n        {% if fields.consumption_total.active %}\n        <div data-field="consumption_total" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">\n            {{fields.consumption_total.label}}: {{billing.consumption_total}}\n        </div>\n        {% endif %}\n\n        {% if fields.service_total.active %}\n        <div data-field="service_total" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">\n            {{fields.service_total.label}}: {{billing.service_total}}\n        </div>\n        {% endif %}\n\n        {% if fields.other_total.active %}\n        <div data-field="other_total" style="border: 1px solid #d1d5db; padding: 8px; text-align: center;">\n            {{fields.other_total.label}}: {{billing.other_total}}\n        </div>\n        {% endif %}\n\n    </div>\n    ',
      defaultSize: {
        width: 700,
        height: 450,
      },
      configuration: {
        category: "billing",
        defaultSize: {
          width: 700,
          height: 450,
        },
        available_fields: [
          {
            field_key: "consumption_charges",
            field_label: "Consumption Charges",
            default_order: 1,
          },
          {
            field_key: "service_charges",
            field_label: "Service Charges",
            default_order: 2,
          },
          {
            field_key: "other_charges",
            field_label: "Other Charges",
            default_order: 3,
          },
          {
            field_key: "consumption_total",
            field_label: "Consumption Charges Total",
            default_order: 4,
          },
          {
            field_key: "service_total",
            field_label: "Service Charges Total",
            default_order: 5,
          },
          {
            field_key: "other_total",
            field_label: "Other Charges Total",
            default_order: 6,
          },
        ],
      },
      isActive: true,
    },
    {
      id: 127,
      componentName: "Total & Adjustments",
      componentAlias: "total_adjustments",
      htmlData:
        '\n    <div data-component="total_adjustments" style="border: 2px solid #1f2937; border-radius: 8px; padding: 20px; background: #f9fafb;">\n\n        <h3 data-role="header" style="margin-bottom: 15px; font-size: 16px; font-weight: bold;">\n            TOTAL &amp; ADJUSTMENTS\n        </h3>\n\n        <div style="font-size: 14px;">\n            \n\n            \n\n            \n\n            \n        </div>\n\n    </div>\n    ',
      htmlSkeleton:
        '\n    <div data-component="total_adjustments" style="border: 2px solid #1f2937; border-radius: 8px; padding: 20px; background: #f9fafb;">\n\n        <h3 data-role="header" style="margin-bottom: 15px; font-size: 16px; font-weight: bold;">\n            {{header_text}}\n        </h3>\n\n        <div style="font-size: 14px;">\n            {% if fields.total_charge.active %}\n            <div>{{fields.total_charge.label}}: {{billing.total_charge}}</div>\n            {% endif %}\n\n            {% if fields.tax.active %}\n            <div>{{fields.tax.label}}: {{billing.tax_amount}}</div>\n            {% endif %}\n\n            {% if fields.credit.active %}\n            <div>{{fields.credit.label}}: -{{billing.credit_applied}}</div>\n            {% endif %}\n\n            {% if fields.net_payable.active %}\n            <div style="margin-top: 10px; font-size: 18px; font-weight: bold;">\n                {{fields.net_payable.label}}: {{billing.net_payable}}\n            </div>\n            {% endif %}\n        </div>\n\n    </div>\n    ',
      defaultSize: {
        width: 400,
        height: 220,
      },
      configuration: {
        category: "billing",
        defaultSize: {
          width: 400,
          height: 220,
        },
        available_fields: [
          {
            field_key: "total_charge",
            field_label: "Total Charges",
            default_order: 1,
          },
          {
            field_key: "tax",
            field_label: "Applicable Tax",
            default_order: 2,
          },
          {
            field_key: "credit",
            field_label: "Credit Applied",
            default_order: 3,
          },
          {
            field_key: "net_payable",
            field_label: "Total Payable Amount",
            default_order: 4,
          },
        ],
      },
      isActive: true,
    },
    {
      id: 123,
      componentName: "Usage History Graph",
      componentAlias: "usage_history_graph",
      htmlData:
        '<div data-component="usage_history_graph" style="width: 100%; height: 100%; display: flex; flex-direction: column; padding: 12px; background-color: white; box-sizing: border-box;"><div style="text-align: center; font-weight: bold; margin-bottom: 8px; color: #1f2937; font-size: 13px;">Usage History (Gas)</div><div style="display: flex; align-items: flex-end; gap: 2px; border-left: 2px solid #e5e7eb; padding-left: 8px; border-bottom: 2px solid #e5e7eb; padding-bottom: 4px;"><div style="display: flex; flex-direction: column; align-items: center; flex: 1; min-width: 0;"><div style="font-size: 10px; color: #4b5563; margin-bottom: 3px; white-space: nowrap; height: 14px;">405</div><div style="width: 100%; height: 150px; display: flex; align-items: flex-end; justify-content: center;"><div style="width: 75%; height: 63%; background-color: #3b82f6; border-radius: 3px 3px 0 0;"></div></div><div style="font-size: 9px; color: #6b7280; margin-top: 3px; white-space: nowrap; height: 14px;">Jul</div></div><div style="display: flex; flex-direction: column; align-items: center; flex: 1; min-width: 0;"><div style="font-size: 10px; color: #4b5563; margin-bottom: 3px; white-space: nowrap; height: 14px;">452</div><div style="width: 100%; height: 150px; display: flex; align-items: flex-end; justify-content: center;"><div style="width: 75%; height: 70%; background-color: #3b82f6; border-radius: 3px 3px 0 0;"></div></div><div style="font-size: 9px; color: #6b7280; margin-top: 3px; white-space: nowrap; height: 14px;">Aug</div></div><div style="display: flex; flex-direction: column; align-items: center; flex: 1; min-width: 0;"><div style="font-size: 10px; color: #4b5563; margin-bottom: 3px; white-space: nowrap; height: 14px;">499</div><div style="width: 100%; height: 150px; display: flex; align-items: flex-end; justify-content: center;"><div style="width: 75%; height: 77%; background-color: #3b82f6; border-radius: 3px 3px 0 0;"></div></div><div style="font-size: 9px; color: #6b7280; margin-top: 3px; white-space: nowrap; height: 14px;">Sep</div></div><div style="display: flex; flex-direction: column; align-items: center; flex: 1; min-width: 0;"><div style="font-size: 10px; color: #4b5563; margin-bottom: 3px; white-space: nowrap; height: 14px;">546</div><div style="width: 100%; height: 150px; display: flex; align-items: flex-end; justify-content: center;"><div style="width: 75%; height: 85%; background-color: #3b82f6; border-radius: 3px 3px 0 0;"></div></div><div style="font-size: 9px; color: #6b7280; margin-top: 3px; white-space: nowrap; height: 14px;">Oct</div></div><div style="display: flex; flex-direction: column; align-items: center; flex: 1; min-width: 0;"><div style="font-size: 10px; color: #4b5563; margin-bottom: 3px; white-space: nowrap; height: 14px;">593</div><div style="width: 100%; height: 150px; display: flex; align-items: flex-end; justify-content: center;"><div style="width: 75%; height: 92%; background-color: #3b82f6; border-radius: 3px 3px 0 0;"></div></div><div style="font-size: 9px; color: #6b7280; margin-top: 3px; white-space: nowrap; height: 14px;">Nov</div></div><div style="display: flex; flex-direction: column; align-items: center; flex: 1; min-width: 0;"><div style="font-size: 10px; color: #4b5563; margin-bottom: 3px; white-space: nowrap; height: 14px;">640</div><div style="width: 100%; height: 150px; display: flex; align-items: flex-end; justify-content: center;"><div style="width: 75%; height: 100%; background-color: #3b82f6; border-radius: 3px 3px 0 0;"></div></div><div style="font-size: 9px; color: #6b7280; margin-top: 3px; white-space: nowrap; height: 14px;">Dec</div></div></div></div>',

      htmlSkeleton:
        '<div data-component="usage_history_graph" style="width: 100%; height: 100%; display: flex; flex-direction: column; padding: 16px; background-color: white;">\n      <div style="text-align: center; font-weight: bold; margin-bottom: 12px; color: #1f2937;">Usage History ({{utility_service}})</div>\n      <div style="flex: 1; display: flex; align-items: flex-end; gap: 4px; border-left: 1px solid #e5e7eb; padding-left: 8px; border-bottom: 1px solid #e5e7eb; padding-bottom: 8px;">\n        <!-- Graph Bars Will Be Generated Here -->\n      </div>\n    </div>',
      defaultSize: {
        width: 600,
        height: 350,
      },
      configuration: {
        category: "analytics",
        defaultSize: {
          width: 600,
          height: 350,
        },
        graphConfig: {
          utilityService: "Gas",
          numberOfMonths: 6,
          showXAxis: true,
          showYAxis: true,
          showValues: true,
        },
        available_fields: [],
      },
      isActive: true,
    },
  ],
};
// utils/mockData.ts
/**
 * Mock Bill Data
 *
 * Sample data used for preview and testing.
 * Replace this with actual API data in production.
 */

export const getBillData = () => MOCK_BILL_DATA;

export const MOCK_BILL_DATA = {
  utility: {
    logoUrl: "/api/placeholder/60/60",
    tagline: "PULEGA O LE SUAVAI",
    name: "SAMOA WATER AUTHORITY",
  },
  customer: {
    name: "John Doe",
    title: "BILLING TO",
    address: "C/O-TOVA SUA (SWA)MATAUTU UTA",
    email: "john.doe@example.com",
    phone: "+685 123 4567",
  },
  account: {
    title: "ACCOUNT DETAILS",
    meterNumber: "166199",
    location: "MATAUTU UTA",
    servicePeriod: "03/12/2024 - 28/02/2025",
    accountNumber: "12019-001",
  },
  meter: {
    previousReading: "595.0",
    currentReading: "625.0",
    consumption: "30.0",
  },
  bill: {
    invoiceNumber: "INV_NO_35676",
    statementDate: "24/02/2025",
    dueDate: "24/02/2025",
    amountDue: "29.25",
    balanceForward: "0.0",
    currentCharges: "29.25",
    totalCharges: "29.25",
    line_items: [
      { description: "Gas Consumption", amount: 45.5 },
      { description: "Service Charge", amount: 10.0 },
      { description: "Tax", amount: 5.55 },
    ],
    consumptionHistory: [
      { month: "Jan", consumption: 123, percentage: 19 },
      { month: "Feb", consumption: 170, percentage: 26 },
      { month: "Mar", consumption: 217, percentage: 33 },
      { month: "Apr", consumption: 264, percentage: 41 },
      { month: "May", consumption: 311, percentage: 48 },
      { month: "Jun", consumption: 358, percentage: 55 },
      { month: "Jul", consumption: 405, percentage: 63 },
      { month: "Aug", consumption: 452, percentage: 70 },
      { month: "Sep", consumption: 499, percentage: 77 },
      { month: "Oct", consumption: 546, percentage: 85 },
      { month: "Nov", consumption: 593, percentage: 92 },
      { month: "Dec", consumption: 640, percentage: 100 },
    ],
    charges: [
      {
        description: "Water Usage",
        consumption: "15.0",
        rate: "0.61",
        amount: "9.15",
        prevReading: "",
        currReading: "",
      },
      {
        description: "Water Usage",
        consumption: "15.0",
        rate: "1.34",
        amount: "20.1",
        prevReading: "",
        currReading: "",
      },
    ],
    totalAmount: "$408.87",
  },
  header: {
    companyName: "SAMOA WATER AUTHORITY",
    logoUrl: "/api/placeholder/60/60",
    showLogo: true,
    invoiceTitle: "INVOICE INFO",
    invoiceNumber: "123000123000",
    statementDate: "03 JUL 2024",
    dueDate: "03 JUL 2024",
    amountDue: "$408.87",
  },
  summary: {
    balanceForward: "$100.00",
    currentCharges: "$308.87",
    amountDue: "$408.87",
  },
  paymentHistory: {
    title: "PAYMENT HISTORY",
    payments: [
      {
        date: "03 Jun 2024",
        amount: "$60.05",
      },
      {
        date: "03 May 2024",
        amount: "$39.97",
      },
      {
        date: "03 Apr 2024",
        amount: "$53.09",
      },
      {
        date: "03 Mar 2024",
        amount: "$27.17",
      },
    ],
  },
  pastDue: {
    title: "PAST DUE AMOUNTS",
    amounts: [
      {
        duration: "30 Days",
        amount: "$60.05",
      },
      {
        duration: "60 Days",
        amount: "$39.97",
      },
      {
        duration: "90 Days",
        amount: "$53.09",
      },
      {
        duration: "Over 90 Days",
        amount: "$27.17",
      },
    ],
  },
  footer: {
    logoUrl: "/api/placeholder/48/48",
    department: "Utility Billing Department",
    address: "P.O. Box 245 Apia; Samoa",
    contacts: [
      "TATTE Sogi 685 20409",
      "Salelologa 685 51215",
      "Vaitele 685 21267",
      "Fax 685 21298",
    ],
    customerInfo: "SETELITE SUA C/O- TOVA SUA (SWA)\nMATAUTU UTA",
  },
  news: {
    title: "NEWS & INFORMATION",
    content:
      "The 20% Water Rate Tariff Reduction concluded on 31/10/2023 for all Commercial customers. Normal Commercial Tariff Rate to commence on 01/11/2023: 40 cubic meters and under @ $1.77 per cubic meter, over 40 cubic meters @2.27 per cubic meter",
  },
  stub: {
    statementDate: "03 Jul 2024",
    paymentAccount: "12019",
    statementNumber: "123000123000",
    totalCharges: "12658",
    dueDate: "06-20-2024",
    amountDue: "$499.88",
    showQRCode: true,
  },
  charges: {
    title: "CURRENT CHARGES & ADJUSTMENTS",
    charges: [
      {
        description: "Balance Forward",
        prevReading: "",
        currReading: "",
        consumption: "",
        rate: "",
        amount: "$100.00",
      },
      {
        description: "Water Usage",
        prevReading: "",
        currReading: "",
        consumption: "15",
        rate: "9.15",
        amount: "",
      },
      {
        description: "Water Usage",
        prevReading: "",
        currReading: "",
        consumption: "25",
        rate: "33.5",
        amount: "",
      },
      {
        description: "Water Usage",
        prevReading: "",
        currReading: "",
        consumption: "153",
        rate: "266.22",
        amount: "",
      },
      {
        description: "Waste Water",
        prevReading: "",
        currReading: "",
        consumption: "",
        rate: "",
        amount: "",
      },
    ],
    totalUsage: {
      prevReading: "00",
      currReading: "50",
      consumption: "50",
      rate: "31",
    },
    totalAmount: "$408.87",
  },
  usage: {
    title: "USAGE HISTORY",
    subtitle: "Monthly Usage History (Cubic Meter)",
    data: [
      {
        month: "Jan",
        value: 50,
        height: "80%",
      },
      {
        month: "Feb",
        value: 40,
        height: "60%",
      },
      {
        month: "Mar",
        value: 30,
        height: "40%",
      },
      {
        month: "Apr",
        value: 45,
        height: "70%",
      },
      {
        month: "May",
        value: 50,
        height: "80%",
      },
      {
        month: "Jun",
        value: 35,
        height: "50%",
      },
    ],
  },
};

// Edit Mode Mock Data (based on user request)
export const MOCK_EDIT_DATA = {
  id: 25,
  templateName: "Test Bill Template v1",
  remoteUtilityId: 312,
  page: {
    size: "A4",
    margin: {
      top: 10,
      left: 10,
      right: 10,
      bottom: 10,
    },
    width_mm: 210,
    height_mm: 297,
    orientation: "portrait",
  },
  pages: {
    front: {
      layout: [
        {
          h: 150, // Converted ratio to pixels/units for our designer
          w: 300,
          x: 0,
          y: 0,
          id: "comp-1",
          component_alias: "logo",
        },
        {
          h: 350,
          w: 500,
          x: 0,
          y: 160,
          id: "comp-2",
          component_alias: "customer_details",
        },
        {
          h: 250,
          w: 450,
          x: 0,
          y: 520,
          id: "comp-3",
          component_alias: "invoice_details",
        },
      ],
      componentConfig: {
        invoice_details: {
          field_order: ["invoice_no", "invoice_date", "due_date", "amount"],
          field_labels: {
            amount: "Total Payable Amount",
          },
        },
        customer_details: {
          field_order: [
            "email",
            "name",
            "account_no",
            "phone",
            "service_address",
          ],
          field_labels: {
            name: "Account Holder Name",
            email: "Customer Email",
            account_no: "Consumer Number",
          },
          field_visibility: {
            phone: false,
          },
        },
      },
    },
    back: {
      layout: [
        {
          h: 200,
          w: 700,
          x: 0,
          y: 0,
          id: "comp-4",
          component_alias: "current_meter_reading",
        },
        {
          h: 100,
          w: 500,
          x: 0,
          y: 210,
          id: "comp-5",
          component_alias: "text_box",
        },
      ],
      componentConfig: {
        current_meter_reading: {
          field_order: [
            "utility_service",
            "meter_no",
            "curr_read",
            "prev_read",
            "consumption",
          ],
          field_labels: {
            curr_read: "Current Reading",
            prev_read: "Previous Reading",
          },
        },
      },
    },
  },
  templateType: "utility_bill",
  category: "meter_replacement",
  perforationLine: {
    enabled: true,
    height: 600,
    x: 0,
    y: 600,
  },
};

export default MOCK_API_RESPONSE;
/**
 * ============================================================
 * MAIN API FUNCTIONS
 * ============================================================
 */

/**
 * Get canvas template
 *
 * FOR TESTING: Returns hardcoded mock data
 * FOR PRODUCTION: Uncomment the real API call below
 */
export const getCanvasComponents = async () => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    "components",
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
    },
  );

  const response = await receiptApiClient.get(url);
  return response.data;
};

/**
 * Fetch list of available base templates for dropdown
 */
export const getTemplateOptions = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `fetch-base-templates`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
    },
  );
  const response = await bxApiClient.get(url);
  return response.data;
};

/**
 * Save new canvas template
 */
export const saveCanvasTemplate = async (payload: any) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    "template-configuration",
  );
  const response = await receiptApiClient.post(url, payload);
  return response.data?.result;
};

/**
 * Update existing canvas template
 */
export const updateCanvasTemplate = async (
  id: string,
  payload: Partial<any>,
) => {
  const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
    "receipt",
    `template-configuration`,
    [id],
  );
  const response = await receiptApiClient.put(url, payload);
  return response.data?.result;
};

/**
 * Get configured template details
 */
export const getConfiguredTemplate = async (id: string) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration/${id}`,
  );
  const response = await receiptApiClient.get(url);
  return response.data?.result;
};

/**
 * Get canvas template detail
 */
export const getCanvasTemplateDetail = async (id: string) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration-detail/${id}`,
  );
  const response = await receiptApiClient.get(url);
  return response.data?.result;
};

export const updateBillTemplate = async (id: string, payload) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration/${id}`,
  );
  const response = await receiptApiClient.put(url, payload);
  return response.data?.result;
};
export const getTemplate = async (templateId?: string | number) => {
  const basePath = "base-template-configuration";
  const path = templateId ? `${basePath}/${templateId}` : basePath;

  const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
    "receipt",
    "base-template-configuration",
    [templateId],
  );
  const response = await bxApiClient.get(url);
  return response.data;
};

export const getTemplateSummary = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `template-summary`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
    },
  );
  const response = await bxApiClient.get(url);
  return response.data;
};

export const getTemplateList = async (
  isActive?: string,
  searchData?: string,
): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
      if (isActive) {
        qs.push("is_active", isActive);
      }
      if (searchData) {
        qs.push("search", searchData);
      }
    },
  );
  const response = await bxApiClient.get(url);
  return response.data;
};

export const cloneBilltemplate = async (id: string | number) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `clone-template-configuration/${id}`,
  );
  const response = await bxApiClient.put(url);
  return response.data?.result;
};

export const changeTemplateStatus = async (
  id: string | number,
  isActive: boolean,
) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration/${id}`,
  );
  const payload = {
    is_active: isActive,
  };
  const response = await bxApiClient.put(url, payload);
  return response.data?.result;
};

export const deleteTemplate = async (id: string | number) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration/${id}`,
  );
  const response = await bxApiClient.delete(url);
  return response.data?.result;
};

export const getTemplateDetail = async (
  id: string | number,
  remoteUtilityId: string,
) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `templates/${id}/detail`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", remoteUtilityId);
    },
  );
  const response = await receiptApiClient.get(url);
  return response.data?.result;
};

export const getTemplateChoices = async (
  filter?: "template_type" | "template"
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `choices/category`,
    (qs: QueryStringParameters) => {
      if (filter) {
        qs.push("filter", filter);
      }
    },
  );
  const response = await receiptApiClient.get(url);
  return response.data;
};

export const archiveTemplate = async (id: string) => {
  const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
    "receipt",
    `archive-template`,
    [id],
  );
  const response = await receiptApiClient.put(url);
  return response.data?.result;
};

export const getTemplateUsage = async (id: string): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `bills-search`,
    (qs: QueryStringParameters) => {
      qs.push("template_id", id);
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
    },
  );
  const response = await receiptApiClient.get(url);
  return response.data;
};

export const getTemplateActivityLog = async (id: string): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `activity-log`,
    (qs: QueryStringParameters) => {
      qs.push("patient_id", id);
      qs.push("entity_type", 4);
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
    },
  );
  const response = await receiptApiClient.get(url);
  return response.data;
};

export const downloadBillTemplate = async (
  templateId: string,
): Promise<Blob> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `generate-receipt/${templateId}`,
  );
  const response = await receiptApiClient.get(url, {
    responseType: "blob",
  });
  return response.data;
};
